import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";
import {
    bilateralAmountDataTableTemplate,
    numberWithCommaDataTableTemplate, percentageDataTableTemplate,
    priceDataTableTemplate
} from "../../utils/formatters/Numbers";

const BilateralAssignedCollateral = (props) => {
    return (
        <React.Fragment>
            {props.messagesGrowl}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubtitleLabel header="Garantías Asignadas" isBold={true}/>
                </Grid>
                <Grid item xs={12}>
                    <DataTable
                        value={props.collateralList}
                        footerColumnGroup={props.footerColumnGroup}
                        resizableColumns={true}
                        columnResizeMode={"fit"}
                        scrollable={true}
                        scrollHeight="400px">
                        <Column
                            field="composeName"
                            header="Emisora"
                            style={{textAlign: 'left'}}
                            sortable={true} />
                        {
                            props.isExcess &&
                            <Column
                                field="haircut"
                                header="% Aforo"
                                style={{textAlign: 'right'}}
                                body={percentageDataTableTemplate}
                                sortable={true}/>
                        }
                        <Column
                            field="title"
                            header="Garantías"
                            body={numberWithCommaDataTableTemplate}
                            sortable={true}/>
                        <Column
                            field="discountedPrice"
                            header="Precio Desc."
                            body={priceDataTableTemplate}
                            sortable={true}/>
                        <Column
                            field="valuatedPrice"
                            header="Precio Mercado"
                            body={priceDataTableTemplate}
                            sortable={true}/>
                        {
                            props.isExcess &&
                            <Column
                                field="suggested"
                                header="Sugerido"
                                body={props.styleInstrumentNumberTemplate}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                        }
                        {
                            props.isExcess &&
                            <Column
                                field="newTitles"
                                header="Títulos"
                                body={props.styleInstrumentNumberTemplate}
                                editor={props.numberEditor}
                                style={{textAlign: 'right'}}
                                sortable={true}/>
                        }
                        <Column
                            field="discountedAmount"
                            header="Importe Garantizado"
                            body={bilateralAmountDataTableTemplate}
                            sortable={true}/>
                        <Column
                            field="amount"
                            header="Importe Mercado"
                            body={bilateralAmountDataTableTemplate}
                            sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

export default BilateralAssignedCollateral;

BilateralAssignedCollateral.propTypes = {
    messagesGrowl: PropTypes.object.isRequired,
    collateralList: PropTypes.array.isRequired,
    footerColumnGroup: PropTypes.object.isRequired,
    isExcess: PropTypes.bool,
    styleInstrumentNumberTemplate: PropTypes.func,
    numberEditor: PropTypes.func,
};